/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentRegimenInvestigation } from 'app/shared/model/treatment-regimen-investigation.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';
import { IUserPanelItem } from 'app/shared/model/user-panel-item.model';
import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';

export interface ITreatmentRegimenInvestigationObs {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  regimenInvestigation?: ITreatmentRegimenInvestigation | null;
  imageStudy?: IRadiologyStudy | null;
  panel?: IDiagLabPanel | null;
  panelItem?: IUserPanelItem | null;
  labTestItemResult?: IUserLabTestItem | null;
}

export const defaultValue: Readonly<ITreatmentRegimenInvestigationObs> = {
  active: false,
};
